import JoinUsView from './join_us_view';

const JoinUs = JoinUsView;
export default JoinUs;
